// extracted by mini-css-extract-plugin
export default {"top":"PayerTable_top__C4Dn","table":"PayerTable_table_aftYt","iconsTH":"PayerTable_iconsTH_apLVN","bidderTH":"PayerTable_bidderTH_m5Ya0","nameTH":"PayerTable_nameTH_JpjPF"};